import postMidasFlow from '@rsos/midas/src/postMidasFlow';
import { captureExceptionWithScope } from '@rsos/utils/sentry';
import { AviveCallStartTimeError } from './aviveSlice';

/**
 * Post to the Avive REM trigger endpoint.
 * @param {string} callflow name
 * @param {Object} callflow variables
 */
export const postREMTrigger = (
  callflow,
  {
    phone,
    location,
    notes = '',
    call_start_time = 0,
    email_address = '',
    requestMethod = 'POST',
    agency_id = '',
    agency_name = '',
  },
) => {
  const variables = {
    phone,
    location,
    call_start_time,
    email_address,
    responder_notes: notes,
    event_type: requestMethod,
    agency_id,
    agency_name,
  };

  if (!Number.isInteger(call_start_time)) {
    // Set the call_start_time to zero so the callflow doesn't fail.
    variables.call_start_time = 0;
    // Record occurrence in sentry.
    captureExceptionWithScope(new AviveCallStartTimeError(call_start_time), {
      requestMethod,
    });
  }

  return postMidasFlow({
    callflow,
    variables,
  });
};
